/**
 * Loading — Indicador de carga unificado en todo el frontend.
 * Fondo blanco con animación de 5 puntos en tonos azul/cyan.
 * Sin texto.
 * @param {boolean} inline - Si true, se adapta al contenedor (modales, secciones)
 */
import React from 'react';
import './Loading.css';

export default function Loading({ inline = false }) {
  const className = inline ? 'loading-screen loading-inline' : 'loading-screen';
  const containerStyle = inline
    ? {
        position: 'relative',
        minHeight: '8rem',
        width: '100%',
        background: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    : {
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100dvh',
        minHeight: '100dvh',
        background: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
      };

  const dotColors = ['#7ef9ff', '#89cff0', '#4682b4', '#0f52ba', '#000080'];
  const dotSize = inline ? 18 : 28;
  const dotMargin = inline ? 8 : 12;

  return (
    <div className={className} style={containerStyle} role="status" aria-live="polite" aria-label="Cargando">
      <div className="loading-dots" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {dotColors.map((color, idx) => (
          <div
            key={color}
            className="loading-dot"
            style={{
              width: `${dotSize}px`,
              height: `${dotSize}px`,
              margin: `${dotMargin}px`,
              borderRadius: '50%',
              background: color,
              animationDelay: `${(idx + 1) * 0.2}s`
            }}
          />
        ))}
      </div>
    </div>
  );
}
